// const Api = "https://appservices.ir:5999/api"; //main
// const Api = "http://192.168.1.114:8686/api"; //main
const Api = "https://api.agrogolaleh.co/api"; //main

const Routes = {
  DashbordReport: Api + "/Wish/DashbordReport",
  AddUser: Api + "/User/AddUser",
  GetUserList: Api + "/User/UsersList",
  GetUser: Api + "/User/GetUser",
  EditUser: Api + "/User/EditUser",
  RolesList: Api + "/Role/RolesList",
  RoleDropDown: Api + "/Role/RoleDropDown",
  AddRole: Api + "/Role/AddRole",
  EditPageAccess: Api + "/Role/EditPageAccess",
  PageAccessList: Api + "/Role/PageAccessList",
  GetRole: Api + "/Role/GetRole",
  EditRole: Api + "/Role/EditRole",
  MenuAccess: Api + "/Role/MenuAccess",
  DeleteRole: Api + "/Role/DeleteRole",
  DeleteUser: Api + "/User/DeleteUser",
  ChangePassword: Api + "/User/ChangePassword",
  Calculate: Api + "/Loan/Calculate",
  DealingItemsList: Api + "/DealingItem/DealingItemsList",
  BuyersList: Api + "/Buyer/BuyersList",
  LoansList: Api + "/Loan/LoansList",
  GetDealingItem: Api + "/DealingItem/GetDealingItem",
  AddLoanDocument: Api + "/Loan/AddLoanDocument",
  GetLoanDocuments: Api + "/Loan/GetLoanDocuments",
  DeleteDocument: Api + "/Document/DeleteDocument",
  GetBuyer: Api + "/Buyer/GetBuyer",
  DealingItemStateDropDown: Api + "/DealingItemState/DealingItemStateDropDown",
  GetDealingFullDetails: Api + "/DealingItem/GetDealingItemFullDetails",
  EditProfile: Api + "/User/EditProfile",
  GetProfile: Api + "/User/GetProfile",
  LoansChart: Api + "/Report/LoansChart",
  CurrentMonthLoanStates: Api + "/Report/CurrentMonthLoanStates",
  BankDropDown: Api + "/Bank/BankDropDown",
  DealingItemStateDrop: Api + "/DealingItemState/DealingItemStateDropDown",

  ///////////////////////////////////
  GetAllImage: Api + "/Site/GetAllImage",
  DeleteImage: Api + "/Site/DeleteImage",
  Login: Api + "/User/Login",
  AddSlider: Api + "/Site/AddImage",

  AddCategory: Api + "/Category/Add",
  GetCategories: Api + "/Category/GetCategories",
  DeleteCategories: Api + "/Category/Delete",
  GetCategoryById: Api + "/Category/GetCategoryById",
  editCategory: Api + "/Category/edit",

  GetConsent: Api + "/Site/GetConsent",
  AddConsent: Api + "/Site/AddConsent",
  GetConsentById: Api + "/Site/GetConsentById",
  DeleteConsent: Api + "/Site/DeleteConsent",
  EditConsent: Api + "/Site/EditConsent",

  GetCertificate: Api + "/Site/GetCertificate",
  AddCertificate: Api + "/Site/AddCertificate",
  DeleteCertificate: Api + "/Site/DeleteCertificate",
  GetCertificateById: Api + "/Site/GetCertificateById",
  EditCertificate: Api + "/Site/EditCertificate",

  GetCooperation: Api + "/Site/GetCooperation",
  AddCooperation: Api + "/Site/AddCooperation",
  DeleteCooperation: Api + "/Site/DeleteCooperation",
  EditCooperation: Api + "/Site/EditCooperation",

  GetCpmpanyInfo: Api + "/Site/GetCpmpanyInfo",
  EditcompanyInfo: Api + "/Site/EditcompanyInfo",

  GetAll: Api + "/Product/GetAll",
  Add: Api + "/Product/Add",
  GetProductById: Api + "/Product/GetProductById",
  Delete: Api + "/Product/Delete",
  Edit: Api + "/Product/Edit",
  DeleteProductGallery: Api + "/Product/DeleteProductGallery",
  AddProductGallery: Api + "/Product/AddProductGallery",

  CheckToken: Api + "/Site/CheckToken",

  GetAppreciation: Api + "/Site/GetAppreciation",
  AddAppreciation: Api + "/Site/AddAppreciation",
  GetAppreciationById: Api + "/Site/GetAppreciationById",
  DeleteAppreciation: Api + "/Site/DeleteAppreciation",
  EditAppreciation: Api + "/Site/EditAppreciation",

  GetHonors: Api + "/Site/GetHonors",
  AddHonors: Api + "/Site/AddHonors",
  DeleteHonors: Api + "/Site/DeleteHonors",
  EditHonors: Api + "/Site/EditHonors",

  GetWorkers: Api + "/Site/GetWorkers",
  AddWorkers: Api + "/Site/AddWorkers",
  DeleteWorkers: Api + "/Site/DeleteWorkers",
  EditWorkers: Api + "/Site/EditWorkers",

  GetAllOrders: Api + "/Order/GetAll",
  GetAllTender: Api + "/Tender/GetAll",
  GetAllState: Api + "/Order/GetAllState",
  ChangeState: Api + "/Order/ChangeState",
  DeleteOrder: Api + "/Order/Delete",
};
export { Routes };
